import React, { useMemo } from 'react';
import cx from 'clsx';

import { IconPrimePostBanner, IconRabbyBanner, IconRabbyDarkBanner } from '@/assets/sidebar';
import { SearchAddress, Card, StickySide } from '@/components';
import { Footer } from '@/components/DesktopFrame/components/Footer';
import { useTheme } from '@/hooks';
import { TopContributors, XPTopUsers } from '@/views/Stream';

import style from './index.module.scss';
import { usePrimePostIssues } from '@/views/Stream/components/IssueSelect/hooks';
import dayjs from 'dayjs';

type Props = {
  className?: string;
  isXP?: boolean;
};

const RABBY_LINK = 'https://debank.com/official-badge/134';

export const SideBox = (props: Props) => {
  const { className, isXP } = props;

  const { isDark } = useTheme();

  return (
    <StickySide className={cx(style.container, className)} offsetBottom={0}>
      <div className={style.top}>
        <SearchAddress className={style.searchInput} isShowRecent={false} includeOfficialAccount />
        <Card className={style.topContributors}>{isXP ? <XPTopUsers /> : <TopContributors />}</Card>
        <a href={RABBY_LINK} target="_blank" rel="noreferrer" className={style.banner}>
          <img
            src={isDark ? IconRabbyDarkBanner : IconRabbyBanner}
            alt="rabby"
            className={style.bannerImg}
          />
        </a>
        <PrimePostBanner />
      </div>

      <Footer className={style.footer} iconGap={12} iconSize={16} />
    </StickySide>
  );
};

const PrimePost_LINK = 'https://debank.com/stream?filter=types%5B%5D%3Dprime_pick';

const PrimePostBanner = () => {
  const { data } = usePrimePostIssues({ enabled: true });
  const ongoingIssue = useMemo(() => data?.[0], [data]);
  const issueName = useMemo(() => `Issue${ongoingIssue?.id}`, [ongoingIssue?.id]);

  const isVoting = useMemo(() => {
    if (!ongoingIssue) {
      return false;
    }
    return dayjs
      .utc()
      .isBetween(dayjs.unix(ongoingIssue?.start_at!), dayjs.unix(ongoingIssue?.end_at!), 'second');
  }, [ongoingIssue]);

  if (!data || !isVoting) {
    return null;
  }

  return (
    <a href={PrimePost_LINK} target="_blank" rel="noreferrer" className={style.primePostBanner}>
      <div className={style.title}>PrimePost {issueName}</div>
      <img src={IconPrimePostBanner} alt="prime" className={style.primePostBannerImg} />
    </a>
  );
};
